import { isEmptyValue as f, format as s } from "../util.mjs";
var u = function(e, r, i, t, a, d) {
  e.required && (!i.hasOwnProperty(e.field) || f(r, d || e.type)) && t.push(s(a.messages.required, e.fullField));
};
export {
  u as default
};
//# sourceMappingURL=required.mjs.map
